import { InvoiceSettingsParams } from "@jugl-web/rest-api";
import { TextInput } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { FieldErrors, UseFormRegister } from "react-hook-form";

type CompanyNameFieldProps = {
  register: UseFormRegister<InvoiceSettingsParams>;
  errors: FieldErrors<InvoiceSettingsParams>;
  value: string;
};

const MAX_LENGTH = 100;

export const CompanyNameField = ({
  register,
  errors,
  value,
}: CompanyNameFieldProps) => {
  const { t } = useTranslations();

  return (
    <div>
      <TextInput
        placeholder={t({
          id: "common.enter",
          defaultMessage: "Enter",
        })}
        {...register("name", {
          maxLength: {
            value: MAX_LENGTH,
            message: `${value.length}/${MAX_LENGTH}`,
          },
          setValueAs: (inputValue) => inputValue.trim(),
          required: {
            value: true,
            message: t({
              id: "inventory-item-form-page.mandatory-field",
              defaultMessage: "Mandatory field",
            }),
          },
          validate: (inputValue) => !!inputValue.trim(),
        })}
        isRequired
        isInvalid={!!errors.name}
        label={t({
          id: "invoices.settings.businessInformation.companyName",
          defaultMessage: "Company name",
        })}
        errorMessage={errors.name?.message}
      />
    </div>
  );
};
